import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthEuropeAfrica"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4934 6.20375 17.7962 1.50661 12 1.5ZM3 12C3.00157 9.44471 4.09287 7.0114 6 5.31074V6.74999C6 7.57841 6.67157 8.24999 7.5 8.24999H10.0365C10.605 8.25025 11.1249 7.92906 11.379 7.42049L11.7127 6.74999H13.5V9.74999H9.92625C9.69381 9.74989 9.46453 9.8038 9.2565 9.90749L6.82875 11.1225C6.32119 11.3765 6.00045 11.8952 6 12.4627V15.2415C5.99996 15.8548 6.37331 16.4064 6.94275 16.6342L9.8295 17.7892L10.338 20.8387C6.08748 20.0358 3.00728 16.3257 3 12ZM11.8845 20.994L11.1705 16.71L7.5 15.2423V12.4635L9.927 11.25H15V5.25H10.7865L10.0365 6.75H7.5V4.21725C9.81188 2.87148 12.6038 2.62796 15.1138 3.55316C17.6237 4.47837 19.5897 6.4757 20.475 9H16.5V12L17.1915 14.8598L15.75 17.0235V20.1713C14.5749 20.7162 13.2953 20.999 12 21C11.961 21 11.9235 20.9948 11.8845 20.994ZM17.25 19.2952V17.4773L18.4395 15.6922C18.674 15.3405 18.7494 14.9062 18.6473 14.496L18 11.9078V10.5H20.865C21.4635 13.8843 20.0555 17.3101 17.25 19.2952Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthEuropeAfrica.vue"]]);
